import { createAction } from 'redux-actions';

export const setDiet = createAction(
  'palliative-care/setDiet',
  dietList => dietList,
);



// WEBPACK FOOTER //
// ./src/lib/dataLayer/diet/actions.js